// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__zbrTi","header":"ClearentDisclaimer_header__3RoFi","inner":"ClearentDisclaimer_inner__1NF0i"};